import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { ApplicationTypeService } from './application-types.service';
import { ApplicationType } from './application-types.interface';
const service = new ApplicationTypeService();

export interface ApplicationTypeState {
   applicationTypes: Array<ApplicationType>;
}

const ApplicationTypeStore: Module<ApplicationTypeState, StoreState> = {
   namespaced: true,
   state: {
      applicationTypes: [],
   },
   getters: {},
   mutations: {
      SET_APPLICATION_TYPES(state, applicationTypes: Array<ApplicationType>) {
         state.applicationTypes = applicationTypes;
      },
   },
   actions: {
      async getApplicationTypes(context) {
         const response = await service.getApplicationTypes();
         context.commit('SET_APPLICATION_TYPES', response.data);
         return response.data;
      },
   },
};

export default ApplicationTypeStore;
